const { createImage, duplicateImage } = require('./Image');

const baseLeader = {
  _version: 6,
  uid: '',
  title: '',
  displayName: '',
  description: '',
  player: '',
  species: '',
  image: createImage(),
  created: '',
  updated: '',
};

const createLeader = (overrides = {}) => ({
  ...baseLeader,
  ...overrides
});

const duplicateLeader = leader => ({
  ...leader,
  image: duplicateImage(leader.image)
});

module.exports = {
  createLeader,
  duplicateLeader
};
